module.exports = __webpack_public_path__ + "assets/img/24_1076.eb69d6a0.jpg";